import { i18n } from '@/locales';
import { isRequired } from './index';
/** 배달대행료 유효성 검사 룰 */
// eslint-disable-next-line import/prefer-default-export
export const createDistributorNoticeFormRule = () => ({
    /** 제목 */
    title: [
        (v) => isRequired(v) || i18n.t('form_rules.value_require'),
    ],
    /** 본문 */
    body: [
        (v) => isRequired(v) || i18n.t('form_rules.value_require'),
    ],
});
